import React from 'react';
import RichText from '../../../../hoc/components/rich-text';
import InformationPanel from '../../../../hoc/components/information-panel';
import Section from '../../../../hoc/components/section/section';
import useTranslation from '../../../../../hooks/useTranslation';

export const NpafFooter = () => {
	const { t } = useTranslation();
	return (
		<Section
			title={t('pages.confirmation.npaf.title')}
			description={t('pages.confirmation.npaf.description')} 
			width="max-w-4xl">
				<InformationPanel>
					<RichText html={t('pages.confirmation.npaf.contact')} />
				</InformationPanel>
		</Section>
	);
};

export default NpafFooter;
